import { render, staticRenderFns } from "./ObjectDetailsInfo.vue?vue&type=template&id=377bd386&"
import script from "./ObjectDetailsInfo.vue?vue&type=script&lang=js&"
export * from "./ObjectDetailsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports